import { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { SupportAgent } from "@mui/icons-material";
import { HiOutlineUsers, HiOutlineCurrencyRupee } from "react-icons/hi2";
import { AiOutlineGold } from "react-icons/ai";
import axios from "axios";

import { decryptText } from "../utils/cipherText";

import { AiOutlineUser } from "react-icons/ai";
import { TbTopologyStar } from "react-icons/tb";

import {
  MdChevronRight,
  MdCorporateFare,
  MdOutlineDashboard,
} from "react-icons/md";
import { RiUser4Line } from "react-icons/ri";
import { LuSettings2 } from "react-icons/lu";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import transactions from "../images/transaction.png";
import loan from "../images/loan.png";
import { IoIosNotificationsOutline } from "react-icons/io";
import { NotificationPopup } from "./NotificationPopup";
import { MdOutlinePayments } from "react-icons/md";
import { IoSettingsOutline } from "react-icons/io5";
import { sideBarContext } from "../App";
import { TbLayoutSidebarLeftCollapseFilled } from "react-icons/tb";
import { TbLayoutSidebarRightCollapseFilled } from "react-icons/tb";
import { IoMdNotificationsOutline } from "react-icons/io";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Example() {
  const { expanded, setExpanded } = useContext(sideBarContext);
  const divRef = useRef(null);
  const selectref = useRef(null);

  const [assetsOpen, setAssetsOpen] = useState(false);
  const [usersOpen, setUsersOpen] = useState(false);
  const [showAccount, setShowAccount] = useState(false);
  const location = useLocation();
  const [lenderDetails, setLenderDetails] = useState([]);
  const userType = decryptText(localStorage.getItem("lender_type"), 7);
  const [notificationModal, setNotificationModal] = useState(false);
  const [loanActionOpen, setLoanActionOpen] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [showSettings, setShowSettings] = useState(false);

  const [repaymentOpen, setRepaymentOpen] = useState(false);

  const [yPos, setYPos] = useState(0);

  console.log("usersOpen", usersOpen);
  const navigation = [
    {
      name: "Dashboard",
      href: "/dashboard",
      icon: MdOutlineDashboard,
      current: location.pathname === "/dashboard" && true,
    },
    [
      {
        name: "KYC Status",
        href: "/kyc",
        icon: HiOutlineUsers,
        current: location.pathname.includes("kyc") && true,
        index: 1,
      },
      {
        name: "Eligible Users",
        href: "/eligibleusers",
        icon: HiOutlineUsers,
        current: location.pathname.includes("eligibleusers") && true,
      },
    ],
    [
      {
        name: "Individuals",
        href: "/assets",
        icon: RiUser4Line,
        current:
          (location.pathname.includes("/assets") ||
            location.pathname.includes("/individuals")) &&
          true,
        index: 2,
      },
      {
        name: "Consolidated",
        href: "/consolidated",
        icon: MdCorporateFare,
        current: location.pathname === "/consolidated" && true,
      },
    ],
    // {
    //   name: "Repayment",
    //   href: "/transactions",
    //   icon: HiOutlineCurrencyRupee,
    //   current: location.pathname === "/transactions" && true,
    // },
    {
      name: "Distributors",
      href: "/distributors",
      icon: TbTopologyStar,
      current: location.pathname === "/distributors" && true,
    },
  ];

  const loanArray = [
    {
      name: "Invoke",
      href: "/invoke",
      icon: RiUser4Line,
      current: location.pathname.includes("/invoke") && true,
    },
    {
      name: "Revoke",
      href: "/revoke",
      icon: RiUser4Line,
      current: location.pathname.includes("/revoke") && true,
    },
  ];
  const repaymentArray = [
    {
      name: "Overdraft",
      href: "/od_transactions",
      icon: RiUser4Line,
      current: location.pathname.includes("/od_transactions") && true,
    },
    {
      name: "Term Loan",
      href: "/transactions",
      icon: RiUser4Line,
      current: location.pathname.includes("/transactions") && true,
    },
  ];
  const account = [
    {
      name: "Settings",
      icon: LuSettings2,
      to: "/settings",
      current: location.pathname === "/settings" && true,
    },

    { name: "Support", icon: SupportAgent, to: "/support" },
    { name: "Profile", icon: AiOutlineUser, to: "/profile" },
    // { name: "Signout", icon: IoLogOut, to: "/signout" },
  ];

  useEffect(() => {
    if (notificationModal) {
      // Add overflow-hidden class to body when modal is open
      document.body.classList.add("overflow-hidden");
    } else {
      // Remove overflow-hidden class from body when modal is closed
      document.body.classList.remove("overflow-hidden");
    }

    // Cleanup function to remove the class if component unmounts
    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, [notificationModal]);
  useEffect(() => {
    const fetchProfileDetails = async () => {
      const token = localStorage.getItem("token");
      // console.log(token, "token");
      const options = {
        method: "GET",
        headers: { Authorization: token },
      };
      try {
        const res = await axios.request(
          `${process.env.REACT_APP_URL}/lender/profile`,
          options
        );
        setLenderDetails(res.data.profile);
        // setRowsPerPage(res.data.order_details.length);
      } catch (error) {
        console.log(error);
      }
    };
    const getNotificationCount = async () => {
      const token = localStorage.getItem("token");
      // console.log(token, "token");
      const options = {
        method: "GET",
        headers: { Authorization: token },
      };
      try {
        const res = await axios.request(
          `${process.env.REACT_APP_URL}/lender/v1/dashboards/notifications/notification_count`,
          options
        );
        if (res.data) {
          setNotificationCount(res.data.count);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchProfileDetails();
    getNotificationCount();
    const notificationInterval = setInterval(getNotificationCount, 100000);
    return () => clearInterval(notificationInterval);
    // getNotificationCount();
  }, []);

  const handleClickOutside = (event) => {
    if (selectref.current && selectref.current.contains(event.target)) {
      return;
    }
    if (divRef.current && !divRef.current.contains(event.target)) {
      setShowSettings(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getClickPosition = (e) => {
    const rowRect = e.currentTarget.getBoundingClientRect();
    const position = rowRect.top;
    setYPos(position + 26);
  };

  const clearOpenMenus = () => {
    setAssetsOpen(false);
    setUsersOpen(false);
    setRepaymentOpen(false);
    setLoanActionOpen(false);
  };

  return (
    <>
      <div>
        {/* Static sidebar for desktop */}
        <div
          className={`hidden lg:fixed lg:inset-y-0 z-50 lg:flex ${
            expanded ? "w-[240px]" : " w-[90px] "
          } lg:flex-col relative transition-all duration-200 ease-in-out`}
        >
          {/* Sidebar component, swap this element with another sidebar if you like */}
          <div className="flex grow flex-col gap-y-5 overflow-y-auto  bg-[#001820] px-4 pb-4 pr-4 pl-2 pt-2">
            <div className="flex h-20 shrink-0 items-center gap-3 pl-5 justify-between pr-2">
              {expanded && (
                <img
                  className="h-[40px] w-auto"
                  src={lenderDetails.logo}
                  alt="Your Company"
                />
              )}

              {
                <button
                  className="uppercase text-white relative"
                  onClick={() => {
                    setExpanded(!expanded);
                    setUsersOpen(false);
                    setAssetsOpen(false);
                    setRepaymentOpen(false);
                    setLoanActionOpen(false);
                  }}
                >
                  {/* <IoIosNotificationsOutline
                    style={{
                      width: "28px",
                      height: "28px",
                    }}
                  />
                  {notificationCount !== 0 && (
                    <span className="absolute -top-1 -right-[7px] bg-[#0ba300] text-white text-xs font-semibold rounded min-w-[20px] min-h-[21px] flex items-center justify-center ">
                      {notificationCount}
                    </span>
                  )} */}
                  {expanded && (
                    <TbLayoutSidebarLeftCollapseFilled
                      style={{
                        width: "27px",
                        height: "27px",
                      }}
                    />
                  )}
                  {!expanded && (
                    <TbLayoutSidebarRightCollapseFilled
                      style={{
                        width: "27px",
                        height: "27px",
                      }}
                    />
                  )}
                </button>
              }
            </div>
            {notificationModal && (
              <NotificationPopup closeFunction={setNotificationModal} />
            )}
            <nav className="flex flex-1 flex-col">
              <ul className="flex flex-1 flex-col">
                <li>
                  <ul className="-mx-2 space-y-3">
                    {navigation.map((item, index) =>
                      Array.isArray(item) ? (
                        <>
                          {index === 2 ? (
                            <li className="space-y-3">
                              <p
                                onClick={(event) => {
                                  if (!expanded) {
                                    setAssetsOpen(!assetsOpen);
                                    setUsersOpen(false);
                                    setRepaymentOpen(false);
                                    setUsersOpen(false);
                                    setLoanActionOpen(false);

                                    getClickPosition(event);
                                    return;
                                  }
                                  if (showAccount) setShowAccount(false);
                                  if (loanActionOpen) setLoanActionOpen(false);
                                  if (usersOpen) setUsersOpen(false);
                                  if (repaymentOpen) setRepaymentOpen(false);
                                  setAssetsOpen(!assetsOpen);
                                }}
                                className={`${
                                  location.pathname === "/assets" ||
                                  location.pathname === "/consolidated" ||
                                  location.pathname.includes("/individuals")
                                    ? "text-white bg-[#001820] hover:bg-[#001F2A] border-l-[5px] border-[#a0ff77]"
                                    : "text-white hover:bg-[#001F2A] bg-[#001820] border-l-[5px] border-transparent"
                                } group  ${
                                  expanded ? "w-[212px]" : " w-fit"
                                } h-[44px] rounded-tr-[8px] rounded-br-[8px] flex gap-x-2 items-center py-3.5 px-6 text-sm leading-6 font-semibold cursor-pointer`}
                              >
                                <AiOutlineGold
                                  className="h-6 w-6 shrink-0"
                                  aria-hidden="true"
                                />
                                {expanded && " Assets"}{" "}
                                {expanded && (
                                  <span className="ml-auto">
                                    {assetsOpen ? (
                                      <FaChevronUp
                                        color="#72B554"
                                        className="w-4 h-4 transition-transform duration-2000 ease-in-out"
                                      />
                                    ) : (
                                      <FaChevronDown
                                        color={
                                          location.pathname === "/assets" ||
                                          location.pathname === "/consolidated"
                                            ? "#72B554"
                                            : "white"
                                        }
                                        className="w-4 h-4 transition-transform duration-2000 ease-in-out"
                                      />
                                    )}
                                  </span>
                                )}
                              </p>
                              {assetsOpen && !expanded && (
                                <InsideItemView
                                  yPos={yPos}
                                  setFunction={setAssetsOpen}
                                  location={location}
                                  userType={userType}
                                  navArray={[
                                    {
                                      name: "Individuals",
                                      to: "/assets",
                                      hideDistributor: false,
                                    },
                                    {
                                      name: "Consolidated",
                                      to: "/consolidated",
                                      hideDistributor: true,
                                    },
                                  ]}
                                />
                              )}
                            </li>
                          ) : (
                            <li className="space-y-3">
                              <p
                                onClick={(event) => {
                                  if (!expanded) {
                                    setUsersOpen(!usersOpen);
                                    setAssetsOpen(false);
                                    setRepaymentOpen(false);
                                    setLoanActionOpen(false);
                                    getClickPosition(event);

                                    return;
                                  }
                                  if (showAccount) setShowAccount(false);
                                  if (loanActionOpen) setLoanActionOpen(false);
                                  if (assetsOpen) setAssetsOpen(false);
                                  if (repaymentOpen) setRepaymentOpen(false);
                                  setUsersOpen(!usersOpen);
                                }}
                                className={`${
                                  location.pathname === "/kyc" ||
                                  location.pathname === "/eligibleUsers"
                                    ? "text-white bg-[#001820] hover:bg-[#001F2A] border-l-[5px] border-[#a0ff77]"
                                    : "text-white hover:bg-[#001F2A] bg-[#001820] border-l-[5px] border-transparent"
                                } group  ${
                                  expanded ? "w-[212px]" : "w-fit"
                                } h-[44px] rounded-tr-[8px] rounded-br-[8px] flex gap-x-2 items-center py-3.5 px-6 text-sm leading-6 font-semibold cursor-pointer`}
                              >
                                <HiOutlineUsers
                                  className="h-6 w-6 shrink-0"
                                  aria-hidden="true"
                                />
                                {expanded ? "Users" : ""}
                                {expanded && (
                                  <span className="ml-auto">
                                    {usersOpen ? (
                                      <FaChevronUp
                                        color="#72B554"
                                        className="w-4 h-4 transition-transform duration-2000 ease-in-out"
                                      />
                                    ) : (
                                      <FaChevronDown
                                        color={
                                          location.pathname === "/kyc" ||
                                          location.pathname === "/eligibleusers"
                                            ? "#72B554"
                                            : "white"
                                        }
                                        className="w-4 h-4 transition-transform duration-2000 ease-in-out"
                                      />
                                    )}
                                  </span>
                                )}
                              </p>
                              {usersOpen && !expanded && (
                                <InsideItemView
                                  yPos={yPos}
                                  setFunction={setUsersOpen}
                                  location={location}
                                  userType={userType}
                                  navArray={[
                                    {
                                      name: "KYC Status",
                                      to: "/kyc",
                                      hideDistributor: false,
                                    },
                                    {
                                      name: "Eligible Users",
                                      to: "/eligibleUsers",
                                      hideDistributor: true,
                                    },
                                  ]}
                                />
                              )}
                            </li>
                          )}
                          {usersOpen &&
                            expanded &&
                            index === 1 &&
                            item.map((subItem) =>
                              userType === "distributors" &&
                              subItem.name === "Eligible Users" ? null : (
                                <>
                                  {
                                    <li key={subItem.name} className="pl-14">
                                      <Link
                                        to={subItem.href}
                                        className={`group w-[146px] h-[45px] flex items-center rounded-tr-[8px] rounded-br-[8px] gap-x-2 py-3.5 px-6 text-sm font-semibold leading-6 ${
                                          subItem.current
                                            ? "border-l-[5px] border-[#a0ff77] text-white bg-[#00394D]"
                                            : "text-white hover:bg-[#00394D] bg-[#001820] border-l-[5px] border-transparent"
                                        }`}
                                      >
                                        {subItem.name}
                                      </Link>
                                    </li>
                                  }
                                </>
                              )
                            )}

                          {assetsOpen &&
                            expanded &&
                            index === 2 &&
                            item.map((subItem) =>
                              userType === "distributors" &&
                              subItem.name === "Consolidated" ? null : (
                                <>
                                  <li
                                    key={subItem.name}
                                    // onClick={() => setAssetsOpen(false)}
                                    className="pl-14"
                                  >
                                    <Link
                                      to={subItem.href}
                                      className={`group w-[146px] h-[45px] flex items-center rounded-tr-[8px] rounded-br-[8px] gap-x-2 py-3.5 px-6 text-sm font-semibold leading-6 ${
                                        subItem.current
                                          ? "border-l-[5px] border-[#a0ff77] text-white bg-[#00394D]"
                                          : "text-white hover:bg-[#00394D] bg-[#001820] border-l-[5px] border-transparent"
                                      }`}
                                    >
                                      {/* <subItem.icon
                                        className="h-6 w-6 shrink-0"
                                        aria-hidden="true"
                                      /> */}
                                      {subItem.name}
                                    </Link>
                                  </li>
                                </>
                              )
                            )}
                        </>
                      ) : ((item.href === "/manage" ||
                          item.href === "/loan-action") &&
                          userType !== "admin") ||
                        (localStorage.getItem("lender_uuid") ===
                          "48d6a4b1-980c-440d-9975-533085f9189b" &&
                          item.href === "/mca") ? null : (
                        !(
                          userType === "distributors" &&
                          (item.href === "/manage" ||
                            item.href === "/distributors" ||
                            item.href === "/dashboard" ||
                            item.href === "/usage" ||
                            item.href === "/loan-action" ||
                            item.href === "/mca")
                        ) && (
                          <li
                            onClick={() => {
                              clearOpenMenus();
                            }}
                            key={item.name}
                            className=""
                          >
                            <Link
                              to={item.href}
                              className={`${
                                item.current
                                  ? "text-white bg-[#00394D] hover:bg-[#003446] border-l-[5px] border-[#a0ff77]"
                                  : "text-white hover:bg-[#001F2A] bg-[#001820] border-l-[5px] border-transparent"
                              } group ${
                                expanded ? "w-[212px]" : " w-fit"
                              } h-[44px] rounded-tr-[8px] rounded-br-[8px] flex gap-x-2 items-center py-3.5 px-6 text-sm leading-6 font-semibold`}
                            >
                              {item.name === "Repayment" ? (
                                <img
                                  src={transactions}
                                  alt="transactions"
                                  className=""
                                />
                              ) : item.name === "Loan Action" ? (
                                <img src={loan} alt="loan" className="" />
                              ) : (
                                <item.icon
                                  className="h-6 w-6 shrink-0 text-white"
                                  aria-hidden="true"
                                />
                              )}
                              <span className="text-sm font-semibold text-white">
                                {expanded && item.name}
                              </span>
                            </Link>
                          </li>
                        )
                      )
                    )}

                    {userType !== "distributors" && (
                      <li className="space-y-3">
                        <p
                          onClick={(event) => {
                            if (!expanded) {
                              getClickPosition(event);
                              setAssetsOpen(false);
                              setUsersOpen(false);
                              setLoanActionOpen(false);

                              setRepaymentOpen(!repaymentOpen);
                              return;
                            }
                            if (showAccount) setShowAccount(false);
                            if (assetsOpen) setAssetsOpen(false);
                            if (loanActionOpen) setLoanActionOpen(false);
                            if (usersOpen) setUsersOpen(false);
                            setRepaymentOpen(!repaymentOpen);
                          }}
                          className={`${
                            location.pathname === "/transactions" ||
                            location.pathname.includes("/od_transactions")
                              ? "text-white bg-[#001820] hover:bg-[#001F2A] border-l-[5px] border-[#a0ff77]"
                              : "text-white hover:bg-[#001F2A] bg-[#001820] border-l-[5px] border-transparent"
                          } group ${
                            expanded ? "w-[212px]" : "w-fit"
                          } h-[44px] rounded-tr-[8px] rounded-br-[8px] flex gap-x-2 items-center py-3.5 px-6 text-sm leading-6 font-semibold cursor-pointer`}
                        >
                          <HiOutlineCurrencyRupee
                            className="h-6 w-6 shrink-0"
                            aria-hidden="true"
                          />
                          {expanded && " Transactions"}
                          {expanded && (
                            <span className="ml-auto">
                              {repaymentOpen ? (
                                <FaChevronUp
                                  color="#72B554"
                                  className="w-4 h-4 transition-transform duration-2000 ease-in-out"
                                />
                              ) : (
                                <FaChevronDown
                                  color={
                                    location.pathname === "/transactions" ||
                                    location.pathname.includes(
                                      "/od_transactions"
                                    )
                                      ? "#72B554"
                                      : "white"
                                  }
                                  className="w-4 h-4 transition-transform duration-2000 ease-in-out"
                                />
                              )}
                            </span>
                          )}
                        </p>

                        {repaymentOpen &&
                          expanded &&
                          repaymentArray.map((subItem) =>
                            (localStorage.getItem("lender_id") === "7" ||
                              userType === "distributors") &&
                            subItem.name === "Corporates" ? null : (
                              <>
                                <li
                                  key={subItem.name}
                                  // onClick={() => setAssetsOpen(false)}
                                  className="pl-14"
                                >
                                  <Link
                                    to={subItem.href}
                                    className={`group w-[146px] h-[45px] flex items-center rounded-tr-[8px] rounded-br-[8px] gap-x-2 py-3.5 px-6 text-sm font-semibold leading-6 ${
                                      subItem.current
                                        ? "border-l-[5px] border-[#a0ff77] text-white bg-[#00394D]"
                                        : "text-white hover:bg-[#00394D] bg-[#001820] border-l-[5px] border-transparent"
                                    }`}
                                  >
                                    {/* <subItem.icon
                                        className="h-6 w-6 shrink-0"
                                        aria-hidden="true"
                                      /> */}
                                    {subItem.name}
                                  </Link>
                                </li>
                              </>
                            )
                          )}

                        {repaymentOpen && !expanded && (
                          <InsideItemView
                            yPos={yPos}
                            setFunction={setRepaymentOpen}
                            location={location}
                            userType={userType}
                            navArray={[
                              {
                                name: "Overdraft",
                                to: "/od_transactions",
                              },
                              {
                                name: "Term Loan",
                                to: "/transactions",
                              },
                            ]}
                          />
                        )}
                      </li>
                    )}
                    {/* ///// */}
                    {userType !== "distributors" && (
                      <li className="space-y-3">
                        <p
                          onClick={(event) => {
                            if (!expanded) {
                              getClickPosition(event);

                              setUsersOpen(false);
                              setAssetsOpen(false);
                              setRepaymentOpen(false);
                              setLoanActionOpen(!loanActionOpen);
                              return;
                            }
                            if (showAccount) setShowAccount(false);
                            if (assetsOpen) setAssetsOpen(false);
                            if (usersOpen) setUsersOpen(false);
                            if (repaymentOpen) setRepaymentOpen(false);
                            setLoanActionOpen(!loanActionOpen);
                          }}
                          className={`${
                            location.pathname === "/invoke" ||
                            location.pathname.includes("/revoke")
                              ? "text-white bg-[#001820] hover:bg-[#001F2A] border-l-[5px] border-[#a0ff77]"
                              : "text-white hover:bg-[#001F2A] bg-[#001820] border-l-[5px] border-transparent"
                          } group ${
                            expanded ? "w-[212px]" : "w-fit"
                          } h-[44px] rounded-tr-[8px] rounded-br-[8px] flex gap-x-2 items-center py-3.5 px-6 text-sm leading-6 font-semibold cursor-pointer`}
                        >
                          <MdOutlinePayments
                            className="h-6 w-6 shrink-0"
                            aria-hidden="true"
                          />
                          {expanded && "Loan Action"}
                          {expanded && (
                            <span className="ml-auto">
                              {loanActionOpen ? (
                                <FaChevronUp
                                  color="#72B554"
                                  className="w-4 h-4 transition-transform duration-2000 ease-in-out"
                                />
                              ) : (
                                <FaChevronDown
                                  color={
                                    location.pathname === "/invoke"
                                      ? "#72B554"
                                      : "white"
                                  }
                                  className="w-4 h-4 transition-transform duration-2000 ease-in-out"
                                />
                              )}
                            </span>
                          )}
                        </p>
                        {loanActionOpen &&
                          expanded &&
                          loanArray.map((subItem) =>
                            (localStorage.getItem("lender_id") === "7" ||
                              userType === "distributors") &&
                            subItem.name === "Corporates" ? null : (
                              <>
                                <li
                                  key={subItem.name}
                                  // onClick={() => setAssetsOpen(false)}
                                  className="pl-14"
                                >
                                  <Link
                                    to={subItem.href}
                                    className={`group w-[146px] h-[45px] flex items-center rounded-tr-[8px] rounded-br-[8px] gap-x-2 py-3.5 px-6 text-sm font-semibold leading-6 ${
                                      subItem.current
                                        ? "border-l-[5px] border-[#a0ff77] text-white bg-[#00394D]"
                                        : "text-white hover:bg-[#00394D] bg-[#001820] border-l-[5px] border-transparent"
                                    }`}
                                  >
                                    {/* <subItem.icon
                                        className="h-6 w-6 shrink-0"
                                        aria-hidden="true"
                                      /> */}
                                    {subItem.name}
                                  </Link>
                                </li>
                              </>
                            )
                          )}

                        {loanActionOpen && !expanded && (
                          <InsideItemView
                            yPos={yPos}
                            setFunction={setLoanActionOpen}
                            location={location}
                            userType={userType}
                            navArray={[
                              {
                                name: "Invoke",
                                to: "/invoke",
                              },
                              {
                                name: "Revoke",
                                to: "/revoke",
                              },
                            ]}
                          />
                        )}
                      </li>
                    )}

                    {/* /// */}
                    {userType !== "distributors" && (
                      <li key={"unique"} className="">
                        <Link
                          to={"/notification"}
                          className={`${
                            location.pathname === "/notification"
                              ? "text-white bg-[#00394D] hover:bg-[#003446] border-l-[5px] border-[#a0ff77]"
                              : "text-white hover:bg-[#001F2A] bg-[#001820] border-l-[5px] border-transparent"
                          } group ${
                            expanded ? "w-[212px]" : " w-fit"
                          } h-[44px] rounded-tr-[8px] rounded-br-[8px] flex  items-center py-3.5 px-6  gap-x-[10px]   text-sm leading-6 font-semibold`}
                        >
                          {true && (
                            <span className=" relative ">
                              <IoMdNotificationsOutline className="h-6 w-6 shrink-0 text-white" />
                              {notificationCount > 0 && (
                                <span className="absolute top-[-8px] -right-[8px] bg-[#0ba300] text-white text-xs font-semibold rounded min-w-[17px] min-h-[18px] flex items-center justify-center ">
                                  {notificationCount}
                                </span>
                              )}
                            </span>
                          )}
                          <span className="  text-sm font-semibold text-white">
                            {expanded && "Notification"}
                          </span>
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
                {/* <div className="border-t border-[#ffffff]/30 my-4"></div>
                <li>
                  <ul className="-mx-2 space-y-3 mt-1">
                    {secondNavigation.map((item) =>
                      (item.href === "/manage" && userType !== "admin") ||
                      (localStorage.getItem("lender_uuid") ===
                        "48d6a4b1-980c-440d-9975-533085f9189b" &&
                        item.href === "/mca")
                        ? null
                        : !(
                            userType === "distributors" &&
                            (item.href === "/manage" ||
                              item.href === "/distributors" ||
                              item.href === "/dashboard" ||
                              item.href === "/usage" ||
                              item.href === "/gst-itr" ||
                              item.href === "/mca")
                          ) && (
                            <li key={item.name}>
                              <Link
                                to={item.href}
                                className={classNames(
                                  item.current
                                    ? " text-white bg-[#FFFFFF1A]"
                                    : "text-gray-400 hover:text-white hover:bg-[#FFFFFF1A]",
                                  "group flex gap-x-3 items-center rounded p-2 text-sm leading-6 font-semibold"
                                )}
                              >
                                <item.icon
                                  className="h-6 w-6 shrink-0"
                                  aria-hidden="true"
                                />
                                <span className="text-[15px]">{item.name}</span>
                              </Link>
                            </li>
                          )
                    )}
                  </ul>
                </li> */}
                {/* <li className="mt-auto">
                  {showAccount && (
                    <div
                      className=""
                      onClick={() => {
                        setShowAccount(false);
                      }}
                    >
                      {account.map((item) =>
                        ((localStorage.getItem("lender_id") === "7" &&
                          localStorage.getItem("lender_uuid") !==
                            "48d6a4b1-980c-440d-9975-533085f9189b") ||
                          userType !== "admin") &&
                        item.to === "/settings" ? null : (
                          <Link
                            to={item.to}
                            className="group w-[212px] h-[44px] rounded-tr-[8px] rounded-br-[8px] flex gap-x-2 items-center py-3.5 px-4 text-sm leading-6 font-semibold cursor-pointer text-white hover:bg-[#001F2A] bg-[#001820] border-l-[5px] border-transparent"
                          >
                            <item.icon
                              className="h-6 w-6 shrink-0"
                              aria-hidden="true"
                            />
                            {item.name}
                          </Link>
                        )
                      )}
                    </div>
                  )}
                  <p
                    onClick={() => {
                      if (loanActionOpen) setLoanActionOpen(false);
                      if (assetsOpen) setAssetsOpen(false);
                      if (usersOpen) setUsersOpen(false);
                      setShowAccount(!showAccount);
                    }}
                    className={classNames(
                      showAccount
                        ? "text-white bg-[#001820] hover:bg-[#001F2A] border-l-[5px] border-[#a0ff77]"
                        : "text-white hover:bg-[#001F2A] bg-[#001820] border-l-[5px] border-transparent",
                      "group w-[212px] h-[44px] rounded-tr-[8px] rounded-br-[8px] flex gap-x-2 items-center py-3.5 px-4 text-sm leading-6 font-semibold cursor-pointer"
                    )}
                  >
                    <RiListSettingsLine
                      className="h-6 w-6 shrink-0"
                      aria-hidden="true"
                    />

                    {lenderDetails.name || "Account"}
                  </p>
                </li> */}
                <li className="mt-auto">
                  <div
                    ref={selectref}
                    onClick={() => setShowSettings(!showSettings)}
                    className={classNames(
                      showSettings ||
                        location.pathname === "/profile" ||
                        location.pathname === "/support" ||
                        location.pathname === "/ltv" ||
                        location.pathname === "/collateral-configuration" ||
                        location.pathname === "/loan-configuration"
                        ? "text-white bg-[#00394D] hover:bg-[#003446] border-l-[5px] border-[#a0ff77]"
                        : "text-white hover:bg-[#001F2A] bg-[#001820] border-l-[5px] border-transparent",
                      "group w-full h-[44px] rounded-tr-[8px] rounded-br-[8px] flex gap-x-2 items-center py-3.5 px-4 text-sm leading-6 font-semibold cursor-pointer"
                    )}
                    // className="group w-[212px] h-[44px] rounded-tr-[8px] rounded-br-[8px] flex gap-x-2 items-center py-3.5 px-4 text-sm leading-6 font-semibold cursor-pointer text-white hover:bg-[#001F2A] bg-[#001820] border-l-[5px] border-transparent"
                  >
                    <IoSettingsOutline
                      className="h-6 w-6 shrink-0"
                      aria-hidden="true"
                    />
                    {expanded && "Settings"}
                  </div>
                  {showSettings && (
                    <div
                      ref={divRef}
                      onClick={() => {
                        if (loanActionOpen) setLoanActionOpen(false);
                        if (assetsOpen) setAssetsOpen(false);
                        if (usersOpen) setUsersOpen(false);
                        if (showAccount) setShowAccount(false);
                        setShowSettings(!showSettings);
                      }}
                      className={`absolute right-[-200px] bottom-4 bg-white w-[269px] h-fit z-10 rounded-lg p-3 shadow-xl`}
                    >
                      {userType === "admin" && (
                        <>
                          {" "}
                          <p className="text-[#A8A8A8] text-xs font-semibold">
                            Financial Configuration
                          </p>
                          <div className="flex flex-col justify-start items-start mt-2 w-full">
                            {/* <Link
                          to={"/collateral-configuration"}
                          className={`flex flex-row justify-between items-center w-full cursor-pointer py-1 px-2 rounded-lg hover:bg-[#F3F3F3] ${
                            location.pathname === "/collateral-configuration" &&
                            "bg-[#A0FF77] hover:bg-[#A0FF77]"
                          }`}
                        >
                          <p className="text-sm font-medium">
                            Collateral Configuration{" "}
                          </p>
                          <MdChevronRight size={"20px"} color="black" />
                        </Link> */}
                            <Link
                              to={"/ltv"}
                              className={`mt-2 flex flex-row justify-between items-center w-full cursor-pointer py-1 px-2 rounded-lg hover:bg-[#F3F3F3] ${
                                location.pathname === "/ltv" &&
                                "bg-[#A0FF77] hover:bg-[#A0FF77]"
                              }`}
                            >
                              <p className="text-sm font-medium">
                                LTV Configuration{" "}
                              </p>
                              <MdChevronRight size={"20px"} color="black" />
                            </Link>
                            {/* <Link
                          to={"/loan-configuration"}
                          className={`mt-2 flex flex-row justify-between items-center w-full cursor-pointer py-1 px-2 rounded-lg hover:bg-[#F3F3F3] ${
                            location.pathname === "/loan-configuration" &&
                            "bg-[#A0FF77] hover:bg-[#A0FF77]"
                          }`}
                        >
                          <p className="text-sm font-medium">
                            Loan Configuration{" "}
                          </p>
                          <MdChevronRight size={"20px"} color="black" />
                        </Link> */}
                          </div>
                        </>
                      )}

                      <p className="text-[#A8A8A8] text-xs font-semibold mt-4">
                        Account
                      </p>
                      <div className="flex flex-col justify-start items-start mt-2 w-full">
                        <Link
                          to={"/profile"}
                          className={`flex flex-row justify-between items-center w-full cursor-pointer py-1 px-2 rounded-lg hover:bg-[#F3F3F3] ${
                            location.pathname === "/profile" &&
                            "bg-[#A0FF77] hover:bg-[#A0FF77]"
                          }`}
                        >
                          <p className="text-sm font-medium">Profile </p>
                          <MdChevronRight size={"20px"} color="black" />
                        </Link>
                        {userType === "admin" && (
                          <Link
                            to={"/settings"}
                            className={`mt-2 flex flex-row justify-between items-center w-full cursor-pointer py-1 px-2 rounded-lg hover:bg-[#F3F3F3] ${
                              location.pathname === "/settings" &&
                              "bg-[#A0FF77] hover:bg-[#A0FF77]"
                            }`}
                          >
                            <p className="text-sm font-medium">
                              Admin Settings{" "}
                            </p>
                            <MdChevronRight size={"20px"} color="black" />
                          </Link>
                        )}
                      </div>
                      <p className="text-[#A8A8A8] text-xs font-semibold mt-4">
                        More info and support
                      </p>
                      <div className="flex flex-col justify-start items-start mt-2 w-full">
                        <Link
                          to={"/support"}
                          className={`flex flex-row justify-between items-center w-full cursor-pointer py-1 px-2 rounded-lg hover:bg-[#F3F3F3] ${
                            location.pathname === "/support" &&
                            "bg-[#A0FF77] hover:bg-[#A0FF77]"
                          }`}
                        >
                          <p className="text-sm font-medium">Help</p>
                          <MdChevronRight size={"20px"} color="black" />
                        </Link>
                      </div>
                    </div>
                  )}
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
}

const InsideItemView = ({
  location,
  divRef,
  navArray,
  setFunction,
  yPos,
  userType,
}) => {
  return (
    <div
      style={{
        top: `${yPos - 44}px`,
      }}
      ref={divRef}
      onClick={() => {}}
      className={`absolute right-[-194px]  shadow-custom-layer1   bg-white w-[190px] h-fit z-10 rounded-lg p-1  flex flex-col gap-[2px]`}
    >
      {navArray.map((item) => {
        if (userType === "distributors" && item.hideDistributor) return <></>;
        return (
          <Link
            onClick={() => {
              setFunction(false);
            }}
            to={item.to}
            className={`flex flex-row justify-between items-center w-full cursor-pointer py-[9.5px] px-3 rounded-lg hover:bg-[#F3F3F3] ${
              location.pathname === item.to && "bg-[#A0FF77] hover:bg-[#A0FF77]"
            }`}
          >
            <p className="text-sm font-medium">{item.name} </p>
          </Link>
        );
      })}
    </div>
  );
};
